import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=47ea704e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ea704e')) {
      api.createRecord('47ea704e', component.options)
    } else {
      api.reload('47ea704e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=47ea704e&", function () {
      api.rerender('47ea704e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21Yv1baC93sym/JS/comp/ImgFallback.vue"
export default component.exports